import { render, staticRenderFns } from "./JcdcDataTable.vue?vue&type=template&id=11a3f484"
import script from "./JcdcDataTable.vue?vue&type=script&lang=ts"
export * from "./JcdcDataTable.vue?vue&type=script&lang=ts"
import style0 from "./JcdcDataTable.vue?vue&type=style&index=0&id=11a3f484&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports